"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
const teamMembers = [{
  name: "Julianna Sterling",
  role: "Lead Event Designer",
  bio: "Julianna is the creative heart of Signature Occasions. With a background in fine arts and a passion for floral architecture, she crafts immersive environments that capture the essence of every couple's unique love story.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/planner_julianna_sterling.png",
  favoriteMaterial: "Hand-Pressed Lavender Silk"
}, {
  name: "Alistair Vance",
  role: "Senior Logistics Director",
  bio: "Alistair manages the intricate dance of high-profile events with effortless grace. His expertise in large-scale corporate galas ensures that every technical detail is executed with silver-standard precision.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/planner_alistair_vance.png",
  favoriteMaterial: "Polished Brushed Silver"
}, {
  name: "Elena Rossi",
  role: "Catering & Experience Curator",
  bio: "Elena believes that an event is a sensory journey. She collaborates with world-class chefs to design bespoke menus that are as visually stunning as they are delicious, ensuring a truly memorable guest experience.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/planner_elena_rossi.png",
  favoriteMaterial: "Frosted Crystal Glass"
}, {
  name: "Sebastian Thorne",
  role: "Technical Production Lead",
  bio: "Sebastian brings the magic of light and sound to our celebrations. From intimate candlelit dinners to grand ballroom transformations, his technical mastery creates the perfect atmosphere for every moment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687098/img/planner_sebastian_thorne.png",
  favoriteMaterial: "Dichroic Architectural Film"
}];
export default function MeetTheTeam() {
  return <section data-section-id="240364" id="meet-the-team" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-default font-light text-primary mb-4 tracking-tight">
            The Creative Visionaries
          </h2>
          <p className="text-lg text-muted-foreground font-sans font-light tracking-wide">
            Meet the artisans behind Signature Occasions. A dedicated collective of experts committed to the art of the atmosphere and the elegance of your celebration.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {teamMembers.map((member, i) => <div key={i} data-index={i} className="group flex flex-col">
              <div className="relative overflow-hidden mb-5 aspect-[3/4] bg-muted rounded-lg border-2 border-secondary shadow-lg">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" />
                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="secondary" size="icon" className="absolute bottom-4 right-4 rounded-lg opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 shadow-md bg-white/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground border border-secondary">
                      <Plus className="w-5 h-5" />
                      <span className="sr-only">View {member.name}'s profile</span>
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="sm:max-w-md bg-background/95 backdrop-blur-xl border-secondary rounded-lg shadow-4xl">
                    <DialogHeader>
                      <DialogTitle className="font-default text-3xl font-light text-primary">{member.name}</DialogTitle>
                      <DialogDescription className="text-xs uppercase tracking-widest font-sans text-primary/70 font-semibold">
                        {member.role}
                      </DialogDescription>
                    </DialogHeader>
                    <div className="mt-6 space-y-6">
                      <p className="text-foreground/80 leading-relaxed text-sm sm:text-base font-sans font-light">
                        {member.bio}
                      </p>
                      <div className="bg-accent/50 p-5 border border-secondary/50 rounded-md">
                        <h4 className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-2 font-bold">Fun Fact</h4>
                        <p className="font-serif text-lg text-primary italic">Signature Element: {member.favoriteMaterial}</p>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
              <div>
                <h3 className="text-xl font-default font-medium text-foreground tracking-tight">{member.name}</h3>
                <p className="text-[11px] font-sans text-primary font-semibold uppercase tracking-[0.15em] mt-1.5">{member.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}